import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  panelAnimations,
} from '@iris/modules/emails/emails-list-view/components/advanced-search-panel/advanced-search-panel.animations';
import {
  IrisApplicationSwitcherComponent,
} from '@iris/modules/launchpad/components/application-switcher/application-switcher.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'header-applications-menu',
  imports: [
    IrisApplicationSwitcherComponent,
    TranslatePipe,
  ],
  templateUrl: './header-applications-menu.component.html',
  styleUrl: './header-applications-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    panelAnimations.transformPanelWrap,
    panelAnimations.transformPanel,
  ],
  host: {
    '[@transformPanelWrap]': '',
  },
})
export class HeaderApplicationsMenuComponent {

}
